import { } from "./base";

export interface AreaInfo {
    id: number; //编号
    parentId: number; //父ID
    name: string; //地区名称
    childrens?: AreaInfo[] | null; //子地区
}

export const defaultCity: AreaInfo = {
    id: 226,
    parentId: 19,
    name: "深圳市"
}

export interface BannerInfo {
    id: number; //编号
    imgUrl: string; //banner图片地址
    title: string; //标题
    summary: string; //摘要
    url: string; //链接地址
    createTime: string; //创建时间
}